import { IssuesCount } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';

import { CHART_CONSTANTS } from '../constants';
import { ChartDataPoint } from '../types';

type ChartPattern = {
	id: string;
	label: string;
	color: string;
};

type TransformResult = {
	chartData: ChartDataPoint[];
	patterns: ChartPattern[];
	maxValue: number;
};

const CHART_PATTERNS: ChartPattern[] = [
	{
		id: 'critical',
		label: 'Critical',
		color: CHART_CONSTANTS.COLORS.CRITICAL
	},
	{
		id: 'serious',
		label: 'Serious',
		color: CHART_CONSTANTS.COLORS.SERIOUS
	}
];

const formatDateForChart = (date: Date): string => {
	return date.toLocaleDateString('en-US', {
		month: 'short',
		day: '2-digit',
		year: 'numeric'
	});
};

export const prepareDataForCriticalIssuesStackedChart = (data: IssuesCount[]): TransformResult => {
	if (!data?.length) {
		return { chartData: [], patterns: [], maxValue: 0 };
	}

	const sortedData = [...data].sort((a, b) => a.day.getTime() - b.day.getTime());
	const chartData: ChartDataPoint[] = sortedData.map((item) => ({
		date: formatDateForChart(item.day),
		critical: item.critical,
		serious: item.serious,
		total: item.total
	}));

	const allValues = sortedData.flatMap((item) => [
		item.critical || 0,
		item.serious || 0,
		(item.critical || 0) + (item.serious || 0)
	]);
	const maxValue = Math.max(...allValues);

	return {
		chartData,
		patterns: CHART_PATTERNS,
		maxValue
	};
};
